import { socketsStore } from '@ping/stores/sockets.store';

export const socketConnectivityChecker = (socketName: 'Market' | 'Notifications', isConnected: boolean) => {
  if (socketName === 'Market') {
    socketsStore.setMarketSocketStatus(isConnected);
  } else {
    socketsStore.setNotificationsSocketStatus(isConnected);
  }
};
